import { render, staticRenderFns } from "./SubjectEditCommonTemplate.vue?vue&type=template&id=7a51c75e&scoped=true"
import script from "./SubjectEditCommonTemplate.vue?vue&type=script&lang=js"
export * from "./SubjectEditCommonTemplate.vue?vue&type=script&lang=js"
import style0 from "./SubjectEditCommonTemplate.vue?vue&type=style&index=0&id=7a51c75e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_css-loader@6.11.0_webpack@5.94.0__handlebar_6db25a2d12e0482dcbfee89f46ef6b8e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a51c75e",
  null
  
)

export default component.exports